module.exports = __webpack_public_path__ + "img/tutorial-public-gallery.45935831.png";